// Static content layer. Replaces the (retired) article server / WordPress backend.
// Content was snapshotted via scripts/capture-articles.mjs into the JSON files here.
// These mirror the exact shape the old endpoints returned, so consuming components
// did not need to change how they read titles, content, dates, images, etc.
//
// To add/edit content now: edit the JSON files in this folder, then rebuild & redeploy.

import postsList from './posts-list.json';
import postsById from './posts-by-id.json';
import printablesList from './printables-list.json';
import printablesById from './printables-by-id.json';

// posts-list.json is already ordered newest-first (as the server returned it).
// Mirrors GET /postslist/:numPosts
export function getPostsList(count) {
  return count ? postsList.slice(0, count) : postsList;
}

// Mirrors GET /posts/:id  (returns null when no matching published article)
export function getPostById(id) {
  return postsById[id] || null;
}

// Mirrors GET /printableslist
export function getPrintablesList() {
  return printablesList;
}

// Mirrors GET /printables/:id
export function getPrintableById(id) {
  return printablesById[id] || null;
}
